import styles from "./BudgetAssistantinfoPopup.scss";
import { getLocalizedStrings } from "./popupLocalizedStrings";


function OutageInfoPopup(props) {
  let BaStrings = getLocalizedStrings("BaAlerts");
  let language= drupalSettings.custom.currentLanguage.current_language;
  let learnMoreLink= "/"+language+"/residential/rebates-savings/budget-assistant-and-you";

  return (
    <div>
      <div className={styles.popUp}>
        <div className={styles.popupContent}>
          {props.infoPopupTxt}
        </div>
      </div>
    </div>
  );
}

export default OutageInfoPopup;